import React from 'react';
import { Text, Box } from './';

const Heading = ({ title, description }) => {
  return (
    <Box pt={5}>
      <Text
        as="h1"
        textAlign="center"
        fontWeight="bold"
        dangerouslySetInnerHTML={{ __html: title }}
        my={5}
      />
      {description && (
        <Text
          color="grey.v3"
          textAlign="center"
          dangerouslySetInnerHTML={{ __html: description }}
          px={[3, 4, 5, 240]}
          mb={5}
        />
      )}
    </Box>
  );
};

export default Heading;
